module.exports = __webpack_public_path__ + "app/components/alerts/alert-details-message-board.view.html";